import { stringify } from '../libs/queryString';

export function getEditorLink({
  metaSiteId,
  editorSessionId,
  petri_ovr,
  dashboardFirstMetaSiteId,
  siteCreationFolderId,
  dashboardFirst,
  autoDetectCategory,
  fromOrigin,
}: {
  metaSiteId: string;
  editorSessionId: string;
  petri_ovr?: string;
  dashboardFirstMetaSiteId?: string;
  siteCreationFolderId?: string;
  dashboardFirst?: string;
  autoDetectCategory?: boolean;
  fromOrigin?: string; // requested by Editor team
}) {
  return `https://manage.wix.com/edit-template/from${dashboardFirstMetaSiteId ? '-intro-siteless' : ''}?${stringify({
    originTemplateId: metaSiteId,
    editorSessionId,
    petri_ovr,
    siteCreationFolderId,
    metaSiteId: dashboardFirstMetaSiteId,
    dashboardFirst,
    autoDetectCategory: autoDetectCategory ? 'true' : undefined,
    fromOrigin,
  })}`;
}

export function getViewerLink({
  templateSlug,
  language,
  originUrl,
  editorSessionId,
  dashboardFirstMetaSiteId,
  dashboardFirst,
  fromOrigin,
}: {
  templateSlug: string;
  language: string;
  originUrl: string;
  editorSessionId: string;
  dashboardFirstMetaSiteId?: string;
  dashboardFirst?: string;
  fromOrigin?: string; // hehehe
}) {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${templateSlug}?${stringify({
    originUrl,
    esi: editorSessionId,
    dashboardFirstMetaSiteId,
    dashboardFirst,
    fromOrigin,
  })}`;
}
